'use strict';

var tokyoDark = {
  name: "tokyoDark",
  anchor: "#1034a6",
  anchorVisited: "#440381",
  borderDark: "#1f2223",
  borderDarkest: "#070809",
  borderLight: "#5e696a",
  borderLightest: "#93a0a1",
  canvas: "#2f3435",
  canvasText: "#F4F4ED",
  canvasTextDisabled: "#1f2223",
  canvasTextDisabledShadow: "#93a0a1",
  canvasTextInvert: "#ffffff",
  checkmark: "#F4F4ED",
  checkmarkDisabled: "#1f2223",
  desktopBackground: "#181a1b",
  flatDark: "#9e9e9e",
  flatLight: "#d8d8d8",
  focusSecondary: "#20FC8F",
  headerBackground: "#1f2223",
  headerNotActiveBackground: "#5e696a",
  headerNotActiveText: "#F4F4ED",
  headerText: "#F4F4ED",
  hoverBackground: "#F61067",
  material: "#465051",
  materialDark: "#1f2223",
  materialText: "#F4F4ED",
  materialTextDisabled: "#1f2223",
  materialTextDisabledShadow: "#93a0a1",
  materialTextInvert: "#ffffff",
  progress: "#F61067",
  tooltip: "#fefbcc"
};

module.exports = tokyoDark;
